"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContentAggregateSearch = void 0;

var basic_frontend_common_1 = require("basic-frontend-common");

var react_1 = __importStar(require("react"));

var react_localization_1 = __importDefault(require("react-localization"));

var components_1 = require("../../../components");

var utils_1 = require("../../../utils");

var json = __importStar(require("./localization.json"));

var PageContentAggregateSearch = function PageContentAggregateSearch(_a) {
  var theme = _a.theme,
      language = _a.language;

  var _b = __read((0, react_1.useState)(language), 2),
      languageState = _b[0],
      setLanguageState = _b[1];

  var _c = __read((0, react_1.useState)(""), 2),
      searchTerm = _c[0],
      setSearchTerm = _c[1];

  var localizedStrings = new react_localization_1["default"](json);
  localizedStrings.setLanguage((0, basic_frontend_common_1.getLanguage)());
  var leadText = searchTerm ? localizedStrings.formatString(localizedStrings.sharedContent.pages.pageContentAggregateSearch.leadSearchTerm, searchTerm).toString() : localizedStrings.sharedContent.pages.pageContentAggregateSearch.leadText;
  return react_1["default"].createElement(basic_frontend_common_1.ContainerArticle, {
    theme: theme
  }, react_1["default"].createElement(basic_frontend_common_1.IntroComplex, {
    title: "",
    theme: theme,
    lead: leadText,
    component: react_1["default"].createElement("div", {
      className: "flex flex-row items-center self-center w-full"
    }, react_1["default"].createElement("span", {
      className: "w-1/2 md:w-2/3 mr-4 pt-1"
    }, react_1["default"].createElement(basic_frontend_common_1.Input, {
      id: "search-input",
      name: "search-input",
      type: "text",
      value: searchTerm,
      placeholderText: localizedStrings.sharedContent.pages.pageContentAggregateSearch.placeholder,
      onInputChanged: function onInputChanged(value) {
        return (0, utils_1.debounce)(setSearchTerm(value), 750);
      },
      theme: theme
    })), react_1["default"].createElement("span", {
      className: "w-1/2 md:w-1/3"
    }, react_1["default"].createElement(components_1.LanguageSelector, {
      onSelectionChanged: setLanguageState,
      theme: theme,
      defaultValue: languageState,
      language: languageState
    }))),
    containerContent: true,
    hruler: true,
    marginBottom: false,
    marginTop: false,
    paddingBottom: false
  }), react_1["default"].createElement(basic_frontend_common_1.ContainerSection, {
    theme: theme,
    marginTop: true
  }, react_1["default"].createElement(components_1.SuspenseWrapper, {
    theme: theme
  }, react_1["default"].createElement(components_1.SearchContentAggregateList, {
    searchTerm: searchTerm,
    theme: theme,
    language: languageState
  }))));
};

exports.PageContentAggregateSearch = PageContentAggregateSearch;